import React from "react";
import { CautionIcon } from "~/assets/svg/InterfaceIcon";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const InitialView = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	return (
		<div className="c__noData">
			<CautionIcon />
			<p className="main">
				{t("pages.investment.InvestEvalPage.list.contents.InitialView.main")}
			</p>
			<p className="sub">
				{t("pages.investment.InvestEvalPage.list.contents.InitialView.sub")}
			</p>
			<button
				type="button"
				color="primary"
				className="btn__solid btn-search"
				onClick={() => navigate("/invest/list")}
			>
				투자 기업 검색
			</button>
		</div>
	);
};

export default InitialView;
